import {Dialog} from '@angular/cdk/dialog';
import {Injectable, Signal, signal} from '@angular/core';
import {take} from 'rxjs';

import {QuizService} from 'libs/data-access/quiz/src/lib/services/quiz.service';
import {
    ConfirmationModalDialogComponent,
    ConfirmationModalDialogData
} from 'libs/shared/component/src/lib/modals/confirmation-modal-dialog/confirmation-modal-dialog.component';
import {DialogContainerComponent} from 'libs/shared/ui/src/lib/components/dialog-container/dialog-container.component';

@Injectable({
    providedIn: 'root'
})
export class NotificationActionsService {
    private readonly processingQuiz = signal<boolean>(false);
    public readonly quizCheckInProgress: Signal<boolean> = this.processingQuiz.asReadonly();

    constructor(
        private dialog: Dialog,
        private quizService: QuizService
    ) {}

    openQuiz(quizId: number): void {
        this.processingQuiz.set(true);

        this.quizService
            .checkQuizAvailability(quizId)
            .pipe(take(1))
            .subscribe((response) => {
                this.processingQuiz.set(false);

                if (response.Completed && response.QuizAvailable) {
                    window.open(`/quizzes/view/${quizId}`, '_blank');
                } else {
                    this.dialog.open<boolean, ConfirmationModalDialogData>(ConfirmationModalDialogComponent, {
                        container: DialogContainerComponent,
                        panelClass: ['modal-md'],
                        ariaLabel: `Attention`,
                        data: {
                            Header: 'Attention',
                            Body: `This quiz is no longer available.`,
                            ConfirmName: 'Close'
                        }
                    });
                }
            });
    }
}
